@if (spec) {
    <div class="field">
        <label soho-label for="lm-builder-business-class">{{ 'BusinessClass' | translate }}</label>
        <input
            id="lm-builder-business-class"
            data-automation-id="lm-builder-business-class-input"
            soho-input
            readonly
            class="full-width-100"
            [(ngModel)]="businessClass">
    </div>
    <div class="field">
        <label soho-label for="lm-builder-list-name">{{ 'ListName' | translate }}</label>
        <input
            id="lm-builder-list-name"
            data-automation-id="lm-builder-list-name-input"
            soho-input
            readonly
            class="full-width-100"
            [(ngModel)]="listName">
    </div>
    <div class="field">
        <label soho-label for="lm-builder-data-source">{{ 'ListPersonalizationDataSourceTab' | translate }}</label>
        <input
            id="lm-builder-data-source"
            data-automation-id="lm-builder-data-source-input"
            soho-input
            readonly
            class="full-width-100"
            [(ngModel)]="dataSource">
    </div>
    @if (!spec.isAuditList && (allowAsOfDateReport || asOfDate.trim().length > 0)) {
        <div class="field">
            <label soho-label for="lm-builder-as-of-date">{{ 'CreateReportAsOfDateLabel' | translate }}</label>
            <input
                id="lm-builder-as-of-date"
                data-automation-id="lm-builder-as-of-date-input"
                soho-datepicker
                soho-trackdirty
                [readonly]="!allowAsOfDateReport || isAuditData"
                [(ngModel)]="asOfDate"
                (ngModelChange)="updateAsOfDate()">
        </div>
    }
    @if (allowArchiveReport || isArchiveData) {
        <div class="field lm-no-label">
            <input
                id="lm-builder-archive-data"
                name="lm-builder-archive-data"
                data-automation-id="lm-builder-archive-data-input"
                soho-checkbox
                type="checkbox"
                soho-trackdirty
                [readonly]="!allowArchiveReport"
                [(ngModel)]="isArchiveData"
                (ngModelChange)="updateArchiveDate()">
            <label [forCheckBox]="true" soho-label for="lm-builder-archive-data">{{ 'DisplayingArchiveData' | translate }}</label>
        </div>
    }
    @if (allowAuditReport || isAuditData) {
        <div class="field lm-no-label">
            <input
                id="lm-builder-audit-data"
                name="lm-builder-audit-data"
                data-automation-id="lm-builder-audit-data-input"
                soho-checkbox
                type="checkbox"
                soho-trackdirty
                [readonly]="!allowAuditReport"
                [(ngModel)]="isAuditData"
                (ngModelChange)="updateAuditDate()">
            <label [forCheckBox]="true" soho-label for="lm-builder-audit-data">{{'DisplayingAuditData' | translate}}</label>
        </div>
    }
}
